export const POST_REQUEST = 'registration/POST_REQUEST'
export const POST_SUCCESS = 'registration/POST_SUCCESS'
export const POST_FAILURE = 'registration/POST_FAILURE'

export const EDIT_REGISTRATION = 'registration/EDIT_REGISTRATION'